import { NumberGrid } from '@Animation/mechanics/base/number-grid'
import { NumberSelector } from '@Animation/mechanics/base/number-selector'
import { PreBakedAnimation } from '@Animation/mechanics/base/transition-animation'
import { ExtraDrawAnimationConfig } from '@Animation/types'
import { ExtraDrawsAddOnResult } from '@Config/draw-results-types'

export class ExtraDrawAnimation extends Phaser.GameObjects.Container {
  numberSelector: NumberSelector
  config: ExtraDrawAnimationConfig
  result: ExtraDrawsAddOnResult
  transitionEffect: PreBakedAnimation
  skipToEnd: boolean = false
  numberSelectionStarted: boolean = false

  constructor(
    scene: Phaser.Scene,
    config: ExtraDrawAnimationConfig,
    result: ExtraDrawsAddOnResult,
    numberGrid: NumberGrid,
    preNumberSelected: () => Promise<void>,
    onNumberSelected?: (number: number) => void,
  ) {
    super(scene)
    this.config = config
    this.result = result
    scene.add.existing(this)

    this.numberSelector = new config.numberSelector(
      scene,
      numberGrid,
      [],
      preNumberSelected,
      onNumberSelected,
    )
    this.transitionEffect = new this.config.transition(
      this.scene,
      this.scene.cameras.main.centerX,
      this.scene.cameras.main.centerY,
    )

    this.add(this.transitionEffect)

    this.visible = false
  }

  reset() {
    this.visible = false
  }

  async playTransitionEffect() {
    if (this.skipToEnd) {
      return
    }
    this.visible = true
    this.setDepth(100)
    await this.transitionEffect.playEffect()
  }

  async playNumberSelection() {
    this.visible = true
    await this.numberSelector.targetNumbers(this.result.results.map((result) => result.result))
  }

  async skip() {
    this.skipToEnd = true
    this.transitionEffect.stopEffect()
    this.numberSelector.skip(this.result.results.map((result) => result.result))
  }

  destroy(fromScene?: boolean): void {
    this.removeAll(true)
    super.destroy(fromScene)
  }
}
